import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportOfflineComponent } from './report-offline.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [
    ReportOfflineComponent
  ],
  imports: [
    CommonModule,
    FontAwesomeModule
  ],
  exports: [
    ReportOfflineComponent
  ]
})
export class ReportOfflineModule { }
